import getStore from '../store/appHostStore';
import type AppHostViewState from '../store/schema/AppHostViewState';

export interface HostedApp {
    viewStates: Map<string, AppHostViewState>;
    primaryAppHostId: string | undefined;
}

export default (): HostedApp => ({
    viewStates: getStore().viewStates,
    primaryAppHostId: getStore().primaryAppHostId,
});
